module.exports = __webpack_public_path__ + "2e3223be809dd273234d6c1da767f479.svg";